import type { PainelFinalizadoItem } from "../../../services/painelService";
import {
  formatMesaSalaoLabel,
  isPedidoSalaoFoodfly,
  resolveSalaoProducaoLabels,
} from "./origemPainel";

export const PAINEL_FINALIZADOS_MODAL_PAGE_SIZE = 10;

export function itemMatchesDisplayBusca(
  query: string,
  displayId: number | null | undefined
): boolean {
  const t = query.trim();
  if (!t) return true;
  const needle = t.toLowerCase();
  const d = displayId != null ? String(displayId) : "";
  return d.toLowerCase().includes(needle);
}

function textoContemBusca(texto: string | null | undefined, needle: string): boolean {
  if (!texto?.trim()) return false;
  return texto.trim().toLowerCase().includes(needle);
}

/** Busca em pedidos finalizados: nº, id, nome, mesa/comanda e descrição. */
export function matchesFinalizadoGrupoBusca(
  query: string,
  itens: PainelFinalizadoItem[],
): boolean {
  const t = query.trim();
  if (!t) return true;
  const needle = t.toLowerCase();
  const principal = itens[0];
  if (!principal) return false;

  if (itemMatchesDisplayBusca(t, principal.displayId)) return true;
  if (textoContemBusca(String(principal.orderId), needle)) return true;

  const isSalao = isPedidoSalaoFoodfly({ canalOrigem: principal.canalOrigem });
  if (isSalao) {
    const labels = resolveSalaoProducaoLabels({
      mesaId: principal.salaoMesaId,
      comandaId: principal.salaoComandaId,
      identificador: principal.salaoIdentificador,
      displayId: principal.displayId,
    });
    const salaoTextos = [
      labels.badge,
      labels.secondary,
      labels.mesa,
      labels.cliente,
      labels.comandaLabel,
      labels.pedidoLabel,
      formatMesaSalaoLabel(
        principal.salaoMesaId,
        principal.salaoIdentificador,
      ),
      principal.salaoIdentificador,
      principal.salaoMesaId,
      principal.salaoComandaId,
    ];
    if (salaoTextos.some((txt) => textoContemBusca(txt, needle))) return true;
  } else if (textoContemBusca(principal.customerName, needle)) {
    return true;
  }

  return itens.some((item) => textoContemBusca(item.descricao, needle));
}
